import { useQuery } from '@tanstack/react-query';

import rateGroupRuleService from '~/services/cruises/RateGroupRuleService';

import { rateGroupQueryKeys } from './rateGroupQueryKeys';

export function useGetRateGroupRules(vendorId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: rateGroupQueryKeys.rules(vendorId),
    queryFn: async () => {
      const response = await rateGroupRuleService.list({ vendorId: vendorId! });
      return response.result;
    },
    enabled: enabled && !!vendorId,
    staleTime: Infinity,
  });
}
